// https://standards.buildingsmart.org/IFC/RELEASE/IFC2x3/TC1/HTML/ifcsharedbldgelements/lexical/ifcdoorstyleoperationenum.htm
enum IfcDoorStyleOperationEnum {
    SINGLE_SWING_LEFT = "SINGLE_SWING_LEFT",
    SINGLE_SWING_RIGHT = "SINGLE_SWING_RIGHT",
    DOUBLE_DOOR_SINGLE_SWING = "DOUBLE_DOOR_SINGLE_SWING",
    DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT",
    DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT",
    DOUBLE_SWING_LEFT = "DOUBLE_SWING_LEFT",
    DOUBLE_SWING_RIGHT = "DOUBLE_SWING_RIGHT",
    DOUBLE_DOOR_DOUBLE_SWING = "DOUBLE_DOOR_DOUBLE_SWING",
    SLIDING_TO_LEFT = "SLIDING_TO_LEFT",
    SLIDING_TO_RIGHT = "SLIDING_TO_RIGHT",
    DOUBLE_DOOR_SLIDING = "DOUBLE_DOOR_SLIDING",
    FOLDING_TO_LEFT = "FOLDING_TO_LEFT",
    FOLDING_TO_RIGHT = "FOLDING_TO_RIGHT",
    DOUBLE_DOOR_FOLDING = "DOUBLE_DOOR_FOLDING",
    REVOLVING = "REVOLVING",
    ROLLINGUP = "ROLLINGUP",
    USERDEFINED = "USERDEFINED",
    NOTDEFINED = "NOTDEFINED", // A door with a not defined operation type is considered as a door with a lining, but no panels. It is thereby always open.
  }
  

export default IfcDoorStyleOperationEnum;